import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { CONTACT } from "@/lib/content";

// Rechtliches Impressum gemäß § 5 DDG (Digitale-Dienste-Gesetz).
export default function ImpressumPage() {
  return (
    <section data-testid="page-impressum" className="relative pt-36 md:pt-44 pb-24">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.05 }}
        >
          <Link
            to="/"
            data-testid="back-home"
            className="inline-flex items-center gap-2 text-ink-muted hover:text-brand-green transition-colors font-semibold"
          >
            <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
          </Link>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1, duration: 0.6 }}
          className="mt-8 font-heading font-extrabold tracking-tight text-ink text-4xl md:text-5xl"
        >
          Impressum
        </motion.h1>

        <div className="mt-10 space-y-10 text-ink-muted text-base md:text-lg leading-relaxed">
          <div>
            <h2 className="font-heading font-bold text-xl text-ink">
              Angaben gemäß § 5 DDG
            </h2>
            <p className="mt-3">
              IgelGemurmel – Igelstation mit Herz
              <br />
              Tanja Heyn
              <br />
              Am alten Sportplatz 16
              <br />
              97478 Knetzgau
            </p>
          </div>

          <div>
            <h2 className="font-heading font-bold text-xl text-ink">Kontakt</h2>
            <p className="mt-3">
              Telefon (nur Notfälle):{" "}
              <a
                href={CONTACT.phoneHref}
                data-testid="impressum-phone"
                className="text-brand-green hover:text-brand-pink transition-colors font-medium"
              >
                {CONTACT.phone}
              </a>
              <br />
              E-Mail:{" "}
              <a
                href={CONTACT.emailHref}
                data-testid="impressum-email"
                className="text-brand-green hover:text-brand-pink transition-colors font-medium break-words"
              >
                {CONTACT.email}
              </a>
            </p>
          </div>

          <div>
            <h2 className="font-heading font-bold text-xl text-ink">
              Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
            </h2>
            <p className="mt-3">
              Tanja Heyn
              <br />
              Am alten Sportplatz 16
              <br />
              97478 Knetzgau
            </p>
          </div>

          <div>
            <h2 className="font-heading font-bold text-xl text-ink">
              Hinweis zur Tätigkeit
            </h2>
            <p className="mt-3">
              Bei IgelGemurmel handelt es sich um eine rein private, ehrenamtliche
              Igelhilfe ohne Gewinnerzielungsabsicht. Es besteht keine
              Umsatzsteuer-Identifikationsnummer, da keine unternehmerische
              Tätigkeit im Sinne des Umsatzsteuergesetzes ausgeübt wird.
            </p>
          </div>

          <div>
            <h2 className="font-heading font-bold text-xl text-ink">
              Streitschlichtung
            </h2>
            <p className="mt-3">
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-brand-green hover:text-brand-pink transition-colors font-medium"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              . Wir sind nicht bereit und nicht verpflichtet, an
              Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
              teilzunehmen.
            </p>
          </div>

          <div>
            <h2 className="font-heading font-bold text-xl text-ink">
              Haftung für Inhalte
            </h2>
            <p className="mt-3">
              Die Inhalte dieser Seite wurden mit größter Sorgfalt erstellt. Für
              die Richtigkeit, Vollständigkeit und Aktualität der Inhalte kann
              jedoch keine Gewähr übernommen werden. Die hier bereitgestellten
              Tipps zur Igelhilfe ersetzen im Ernstfall keine tierärztliche
              Beratung oder Behandlung.
            </p>
          </div>

          <div>
            <h2 className="font-heading font-bold text-xl text-ink">
              Haftung für Links
            </h2>
            <p className="mt-3">
              Unser Angebot enthält gegebenenfalls Links zu externen Websites
              Dritter, auf deren Inhalte wir keinen Einfluss haben. Für die
              Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder
              Betreiber der Seiten verantwortlich.
            </p>
          </div>

          <div>
            <h2 className="font-heading font-bold text-xl text-ink">
              Urheberrecht
            </h2>
            <p className="mt-3">
              Die durch den Seitenbetreiber erstellten Inhalte und Werke auf
              diesen Seiten unterliegen dem deutschen Urheberrecht. Beiträge
              Dritter sind als solche gekennzeichnet.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
